<template>
  <div class="rightSection">
    <slot name="quickFilter"></slot>
    <div class="searchBox fix-width__medium">
      <el-input
        class="input-border__bottom input-border__radius__0"
        v-model="keyword_"
        size="medium"
        placeholder="Nhập từ khoá"
        @keydown.enter.exact.native="simpleSearch"
      >
        <i slot="suffix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>

    <el-popover
      placement="top-start"
      width="700"
      trigger="click"
      v-if="!isDisableAdvanceSearch"
      v-model="isShowAdvanceSearch"
    >
      <el-tooltip content="Tìm kiếm nâng cao" placement="top" slot="reference">
        <i
          class="fas fa-filter clickable color__blue"
          @click="$emit('search')"
        ></i>
      </el-tooltip>

      <slot name="advance" v-if="isShowAdvanceSearch"></slot>
    </el-popover>
  </div>
</template>

<script>
  export default {
    name: "search-template-v2",
    props: ["keyword", "isDisableAdvanceSearch"],
    data() {
      return {
        keyword_: "",
        isShowAdvanceSearch: false
      };
    },
    created() {
      this.keyword_ = this.keyword;
    },
    watch: {
      keyword(newValue) {
        this.keyword_ = newValue;
      }
    },
    methods: {
      simpleSearch() {
        this.isShowAdvanceSearch = false;
        this.$emit("simpleSearch", this.keyword_);
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/common/layout/search-template-v2.vue